
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Allocations extends Vue {
  grid = { page: 0 };
  rows = 20;
  url = "/api/allocation/grid/data?rows=" + this.rows;
  showFilter = false;
  name = "";
  client = "";
  vehicle = "";
  menu1 = false;
  filterUrl = "";
  on = null;
  page = 1;

  get loading() {
    return common.loading;
  }

  async mounted() {
    common.setLoading(true);
    try {
      this.grid = await doGet(this.url);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async showPage(page) {
    this.page = page;
    this.grid = await doGet(this.url + this.filterUrl + "&page=" + page);
    common.setLoading(false);
  }

  async clear() {
    this.name = "";
    this.client = "";
    this.vehicle = "";
    this.search();
  }

  async search() {
    this.filterUrl = "";
    if (this.name) this.filterUrl += "&name=" + this.name;
    if (this.client) this.filterUrl += "&client_id=" + this.client;
    if (this.vehicle) this.filterUrl += "&vehicle=" + this.vehicle;
    common.setLoading(true);
    await this.showPage(1);
  }

  async deleteCampus(allocation) {
    common.setLoading(true);
    try {
      await doGet("/api/allocation/delete/" + allocation._id);
      common.showMessage("Deleted Successfully");
      await this.search();
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }
}
